import { render, staticRenderFns } from "./ChildCourseEditForm.vue?vue&type=template&id=45a841bb"
import script from "./ChildCourseEditForm.vue?vue&type=script&lang=js"
export * from "./ChildCourseEditForm.vue?vue&type=script&lang=js"
import style0 from "./ChildCourseEditForm.vue?vue&type=style&index=0&id=45a841bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports